import { useNavigate } from 'react-router-dom';
import { Button, Container, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';

import { RenderJson } from '@/components';
import { getErrorDisplayMessage, isErrorConfig } from '@/lib/utils';

interface ErrorDisplayProps {
	error: any;
	showBackButton?: boolean;
	showRetryButton?: boolean;
	onRetryButtonClick?(): void;
	className?: string;
}

export const ErrorDisplay = ({
	error,
	showBackButton,
	showRetryButton,
	onRetryButtonClick,
	className,
}: ErrorDisplayProps) => {
	const navigate = useNavigate();
	const isForbidden = isErrorConfig(error) && error.status === 403;
	const displayMessage = getErrorDisplayMessage(error);

	function handleGoBackButtonClick() {
		navigate(-1);
	}

	return (
		<>
			<Container className={classNames('py-10', className)} data-testid="error-display">
				<Row>
					<Col>
						<h3 className="mb-2 text-center text-blue-one">{isForbidden ? 'No Access' : 'Error'}</h3>
						<p className="mb-4 text-center">{displayMessage}</p>
						<div className="d-flex justify-content-center">
							{showBackButton && (
								<Button onClick={handleGoBackButtonClick} className="mr-2">
									Go Back
								</Button>
							)}
							{showRetryButton && <Button onClick={onRetryButtonClick}>Retry</Button>}
						</div>
					</Col>
				</Row>
				{!isForbidden && (
					<Row>
						<Col>
							<RenderJson json={error} />
						</Col>
					</Row>
				)}
			</Container>
		</>
	);
};
